import React from "react";
import { Link } from 'react-router-dom';
import { Button, Container, Nav, Navbar, NavDropdown, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import commonActions from "../redux/common/actions";
import { FiLogOut } from "react-icons/fi";
import { DecryptFunction } from "../utils/cryptoFunction";

export default function Header() {
    let roleId = null;

    if( sessionStorage.getItem('cet_token') ) {
        let userRole = DecryptFunction(sessionStorage.getItem('user_role'));
        userRole = JSON.parse(userRole);
        roleId = userRole.id;
    }

    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch({ type: commonActions.SET_LOGOUT_MODAL, payload: true });
    };

    return (
        <>
        <Container fluid className="header-container-fluid">
            <Container className="header-container header-container-bigscreen">
                <img src={require('../assets/images/logo.png')} alt="logo" className="header-logo" />
                <div className="header-center-content">
                    <img src={require('../assets/images/cet_img.png')} alt="cet" className="header-center-img" />
                    <div className="header-heading-div">
                        <div className="header-heading1">State Common Entrance Test Cell</div>
                        {/* <div className="header-heading1">GOVERNMENT OF MAHARASHTRA</div>
                        <div className="header-heading2">State Common Entrance Test Cell</div> */}
                    </div>
                </div>
                <img src={require('../assets/images/header3_img.png')} alt="header" className="header-right-corner-img" />
            </Container>
            <div className="header-container header-container-smallscreen">
                <img src={require('../assets/images/logo.png')} alt="logo" className="header-logo" />
                <div className="header-center-content">
                    <img src={require('../assets/images/cet_img.png')} alt="cet" className="header-center-img" />
                    <div className="header-heading-div">
                        <div className="header-heading1">State Common Entrance Test Cell</div>
                        {/* <div className="header-heading1">GOVERNMENT OF MAHARASHTRA</div>
                        <div className="header-heading2">State Common Entrance Test Cell</div> */}
                    </div>
                </div>
                <img src={require('../assets/images/header3_img.png')} alt="header" className="header-right-corner-img" />
            </div>            
        </Container>
        { sessionStorage.getItem('cet_token') && (
            <Container fluid >
                <Row className="header-row">
                    <Navbar data-bs-theme="light" className="app-navbar">
                        <Container>
                        <Nav className="me-auto">
                            <Nav.Link as={Link} to="/home">Home</Nav.Link>
                            {DecryptFunction(sessionStorage.getItem('user_type')) === 'Master' &&
                            <>
                            <Nav.Link as={Link} to="/users">User</Nav.Link>
                            <Nav.Link as={Link} to="/reports/registered-candidates-count">Registration Report</Nav.Link>
                            </>
                            }
                            {roleId === 5 &&
                                <>
                                <NavDropdown title="Update Status" id="basic-nav-dropdown">
                                    <NavDropdown.Item as={Link} to="/education-courses?cardId=1">CET Registration</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/education-courses?cardId=6">Hall Ticket</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/education-courses?cardId=7">Objection Tracker</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/education-courses?cardId=8">Score Card</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/education-courses?cardId=3">CAP Registration</NavDropdown.Item>
                                </NavDropdown>
                                </>
                            }
                        </Nav>
                        <Nav className="ms-auto">
                            {/* <Button variant="outline-danger" onClick={handleLogout}>
                            Logout
                            </Button> */}

                            <Button className="menu-logout-btn-cls" onClick={handleLogout}>
                                <FiLogOut className="me-1" /> LOGOUT
                            </Button>
                        </Nav>
                        </Container>
                    </Navbar>
                </Row>
            </Container>
        )}
        </>
    )
};